import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import translations from "../../translation"; // Import translations

const Approved = ({ content, language }) => {
  const [showPopup, setShowPopup] = useState(false);

  // Function to translate static text
  const translate = (key) => translations[language][key] || key;

  return (
    <>
      {/* Main Card */}
      <div
        className="bg-white shadow-lg rounded-lg overflow-hidden transform transition-transform duration-300 hover:scale-105 p-6 cursor-pointer"
        onClick={() => setShowPopup(true)}
      >
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0">
            <div className="check flex-shrink-0">
              <FaCheck className="text-5xl" />
            </div>
          </div>
          <div className="ml-6">
            {/* Static text translated */}
            <h3 className="text-xl font-bold">{translate("approvedTitle")}</h3>
          </div>
        </div>
        <p className="text-gray-600 mb-4">
          {/* Dynamic content remains unchanged */}
          {content} {translate("approvedItemsMessage")}
        </p>
        <p className="text-sm font-medium text-gray-700">
          <span className="text-gray-500">{translate("statusLabel")}: </span>
          {translate("statusApproved")}
        </p>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full">
            <h3 className="text-xl font-bold mb-4">{translate("approvedTitle")}</h3>
            <p className="text-gray-600 mb-4">
              {translate("statusLabel")}: {translate("statusApproved")}
            </p>
            <p className="text-gray-700">
              {/* Dynamic content remains unchanged */}
              {content} {translate("approvedPopupMessage")}.
            </p>
            <button
              className="text-white mt-4 px-4 py-2 bg-red-500 rounded-lg hover:bg-red-400"
              onClick={() => setShowPopup(false)}
            >
              {translate("closeButton")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Approved;
